export const DEVICE_FEE_CATEGORY_ID = 'd5c9bbcd-e9f2-40a0-a4db-2d7b01360715';
